import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-close-button',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RentwareCloseButton {
    @Prop() onClose: () => void = () => { };
    @Prop() disabled: boolean = false;

    closeCallback = () => {
        return this.disabled ?
            null :
            this.onClose();
    }

    get closeClass() {
        return this.disabled ?
            "DateChangeDayContainer DateButtonDisabled" :
            "DateChangeDayContainer";
    }

    render() {
        return (
            <div
                class={this.closeClass}
                tabIndex={0}
                onClick={this.closeCallback}
            >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 6L11 1M6 6L11 11M6 6L1 1M6 6L1 11" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        )
    }
}
